import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBranchTransactionApi,
  SaveBranchTransactionApi,
  DeleteBranchTransactionApi,
  getBranchTransactionCodeApi,
  getBranchAccsApi,
} from "../../apiservice/accounts";
import { getBranchApi, getAccountBySeachApi } from "../../apiservice/setting";

export const fetchBranchTransactionList = createAsyncThunk(
  "branchTransaction/fetchBranchTransactionList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchTransactionApi({ oneDate: null });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createOrUpdateBranchTransaction = createAsyncThunk(
  "branchTransaction/createOrUpdateBranchTransaction",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await SaveBranchTransactionApi(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteBranchTransaction = createAsyncThunk(
  "branchTransaction/deleteBranchTransaction",
  async (tran_id, { rejectWithValue }) => {
    try {
      const res = await DeleteBranchTransactionApi({ tran_id });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchBranchAccounts = createAsyncThunk(
  "branchTransaction/fetchBranchAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["cash_in_hand", "bank_account"],
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchBranchTransactionCode = createAsyncThunk(
  "branchTransaction/fetchBranchTransactionCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchTransactionCodeApi();
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchToBranches = createAsyncThunk(
  "branchTransaction/fetchToBranches",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchApi({ "without-self": "yes" });
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchBranchAccs = createAsyncThunk(
  "branchTransaction/getBranchAccs",
  async (branch_id, { rejectWithValue }) => {
    try {
      const res = await getBranchAccsApi({
        toBranchId: branch_id,
        multiType: ["cash_in_hand", "bank_account"],
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
